/**
 * A two dimensional vector [x, y]; y direction is down the screen.
 */
export type Vector = [number, number]

/**
 * Find the position vector of the mid point between two points specified by vectors.
 */
export const midPoint = ([x0, y0]: Vector, [x1, y1]: Vector): Vector => {
    return [0.5 * (x0 + x1), 0.5 * (y0 + y1)]
}

export const negateVector = ([x, y]: Vector): Vector => [-x, -y]

export const addVectors = ([x0, y0]: Vector, [x1, y1]: Vector): Vector => [
    x0 + x1,
    y0 + y1
]

export const subtractVectors = (a: Vector, b: Vector): Vector => addVectors(a, negateVector(b))

export const scaleVector = (coefficient: number, [x, y]: Vector): Vector => [
    coefficient * x,
    coefficient * y
]



// WEBPACK FOOTER //
// ./src/vector.ts